

exports.__esModule = true;

var _squid = require('squid');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

var _uiRouter = require('uiRouter');

var _logger = require('xo-beaver/dist/logger');

require('xo-ui-components/src/accessibility/directive');

require('xo-ui-components/src/floating-label/directive');

require('xo-ui-components/src/directionality/directive');

require('xo-page-components/src/footer/directive');

var _index = require('xo-models/src/openButton/index');

var _fallback = require('js/lib/fallback');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoOpenButton', {
    tag: 'xo-openbutton-page',
    template: _template2['default'],

    resolve: {
        models: function models() {
            var _this = this;

            _logger.$logger.info('checkout_fpti', { 'from': 'XO_INIT', 'to': 'prepare_openButton' });
            // set jsonWPSParams as one of our models to use cancel_return for example for our template
            this.jsonWPSParams = _squid.$util.decodeAndParse(_squid.$meta.xclickParams);
            this.item = {};

            // send an action to get editable flags and fields for the form and a merchant name
            _index.$OpenButtonModel.instance().action('getData', {
                data: {
                    xClickParams: _squid.$meta.xclickParams
                },
                success: function success(result) {
                    _this.item = result;
                    _this.originalItem = Object.assign({}, result);
                    // if field is non editable and exist - format amount and quantity
                    // to have locale based thousand separators and decimal separators
                    // note: we decided to not have formatted fields when fields are editable
                    if (_this.item.amount && !_this.item.is_editable_amount) {
                        _this.item.amount = (0, _squid.formatCurrency)(_this.item.amount);
                    }
                    if (_this.item.quantity && !_this.item.is_editable_quantity) {
                        _this.item.quantity = (0, _squid.formatQuantity)(_this.item.quantity);
                    }

                    _logger.$logger.info('open_button_data_recieved', result);
                }
            });
        }
    },

    controller: function controller($scope) {

        function isValidAmount(thing) {
            return thing !== undefined && isNaN(thing) === false && +thing > 0;
        }

        $scope.validPrice = function (input) {
            // allow user to enter only a valid price
            if (this.item.is_editable_amount && !isValidAmount(input)) {
                return false;
            }
            return true;
        };

        $scope.validQuantity = function (input) {
            // allow user to enter only a positive integer
            if (this.item.is_editable_quantity && !/^\d*$/.test(input)) {
                return false;
            }
            return true;
        };

        $scope.positionToErrorField = function () {
            var errorFields = $('input:visible.ng-invalid');
            var firstErrorField = errorFields && errorFields.length && errorFields[0];

            // Sets the styling for validation
            $scope.validated = true;
            if (firstErrorField) {
                firstErrorField.focus();
            }

            return true;
        };

        // create a cart and redirect to Hermes after we click Continue
        $scope.onSubmit = function () {
            var _item = this.item,
                amount = _item.amount,
                quantity = _item.quantity,
                item_name = _item.item_name,
                is_editable_amount = _item.is_editable_amount,
                is_editable_quantity = _item.is_editable_quantity;


            if (!is_editable_amount) {
                amount = this.originalItem.amount;
            }
            if (!is_editable_quantity) {
                quantity = this.originalItem.quantity;
            }
            _index.$OpenButtonModel.instance().action('createCart', {
                data: {
                    formData: {
                        amount: amount,
                        quantity: quantity,
                        item_name: item_name
                    },
                    xClickParams: _squid.$meta.xclickParams,
                    flowlogging_id: _squid.$meta.flowlogging_id
                },
                success: function success(result) {
                    var hermesUrl = result.hermesUrl;

                    // redirect to hermes

                    _logger.$logger.info('open_button_redirect_to_hermes', { url: hermesUrl });
                    _logger.$logger.info('checkout_fpti', { 'from': 'OPENBUTTON', 'to': 'process_openButton' });
                    _squid.$util.redirect(hermesUrl);
                },
                contingencies: {
                    DEFAULT: function DEFAULT(errorName) {
                        _logger.$logger.info('open_button_create_cart_error', errorName);
                        if ((0, _fallback.getAllowOpenButtonFallback)()) {
                            throw new _squid.$FallbackError({
                                product: 'wps',
                                reason: errorName
                            });
                        } else {
                            return _uiRouter.$state.go('checkout.error.genericError');
                        }
                    }
                }
            });
        };

        $scope.cancelRedirect = function ($event) {
            $event.preventDefault();
            _logger.$logger.info('checkout_fpti', {
                'from': 'OPENBUTTON',
                'to': 'openButton_return_to_merchant'
            });
            _logger.$logger.info('redirect', {
                url: this.jsonWPSParams.cancel_return
            });
            _squid.$util.redirect(this.jsonWPSParams.cancel_return);
        };
    },

    actions: {
        keyUp: function keyUp(event) {
            event = event || window.event;
            if (event) {
                // 38 : up arrow, 40: down arrow
                if (event.keyCode === 38) {
                    this.actions.increment();
                } else if (event.keyCode === 40) {
                    this.actions.decrement();
                }
            }
        },
        increment: function increment() {
            this.item.quantity++;
        },
        decrement: function decrement() {
            if (this.item.quantity > 1) {
                this.item.quantity--;
            }
        }
    }
});


_squid.$Component;

_squid.$util;

_squid.$meta;

_squid.$FallbackError;

_squid.formatCurrency;

_squid.formatQuantity;

_uiRouter.$state;

_logger.$logger;

_index.$OpenButtonModel;

_fallback.getAllowOpenButtonFallback;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-openbutton/directive.js
// module id = ./pages/xo-openbutton/directive.js
// module chunks = 1